import { z } from 'zod'

import { WeekDays } from '@/shared/types/days/week-days'

const DaysWeekTimesBase = z.object({
  day: WeekDays,
  initTime: z.string(),
  endTime: z.string()
})

export const DaysWeekTimes = DaysWeekTimesBase.extend({
  id: z.string()
})

export const DaysWeekTimesDTO = DaysWeekTimesBase.extend({
  id: z.string().nullable()
})

export const DaysWeekTimesForm = DaysWeekTimesDTO.extend({
  isActive: z.boolean()
})
export type DaysWeekTimesForm = z.infer<typeof DaysWeekTimesForm>
